import React from 'react';

/**
 * Renders nothing unless the appointment is urgent.
 *
 * Urgency is decided by the backend (`is_urgent_effective` = manual flag OR the
 * appointment starts within 48 hours) so the rule lives in one place.
 */
const UrgentBadge = ({ item, style = {} }) => {
  if (!item?.is_urgent_effective) return null;

  return (
    <span
      title={
        item?.is_urgent
          ? 'Marked urgent'
          : 'Starting within 48 hours'
      }
      style={{
        display: 'inline-block',
        padding: '1px 8px',
        borderRadius: 10,
        backgroundColor: '#fee2e2',
        color: '#b91c1c',
        border: '1px solid #fecaca',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      URGENT
    </span>
  );
};

export default UrgentBadge;
